import PIXI from '../GameEngine/pixi.js';
export default class Card extends PIXI.Sprite {
    constructor(card) {
        super();
        //if string change/parse to card
        if (typeof card === "string") {
            let cardId = card;
            let cardNumber = cardId[0];
            let cardSuit = cardId[1];
            if (card.length === 3) {
                cardNumber = cardId.substr(0, 2);
                cardSuit = card.substr(2, 1);
            }
            cardNumber = parseInt(cardNumber);
            card = {
                id: cardId,
                deck: "",
                number: cardNumber,
                value: Math.min(cardNumber, 10),
                suit: cardSuit
            }
        }


        this.id = card.id;
        this.suit = card.suit;
        this.number = card.number;
        this.pile = card.pile;
        this.showfront = card.showfront;
        this.dragging = false;
        this.data = null;
        this.randomId = Math.floor(Math.random() * 1000000);
        this.grayedOut = false;

        //this.card = card; //do i want each card to hold a reference to the card model or just update on onChange from base model?

        this.updateTexture();

        this.interactive = true;
        this.buttonMode = true;
        this.anchor.set(0.5);
        //this.width = 115;
        //this.height = 161;
        //this.width = 150;
        //this.height = 210;
        //this.width = 50;
        //this.height = 150;

        //this.scale.set(0.6, 0.6);

        // this
        //     .on('pointerdown', this.onDragStart)
        //     .on('pointerup', this.onDragEnd)
        //     .on('pointerupoutside', this.onDragEnd)
        //     .on('pointermove', this.onDragMove);

        this.onChange = () => { };
    }
    updateTexture() {
        //let loader = PIXI.Loader.shared;
        // if (!loader.resources["Deck"]) return;
        // if (!loader.resources["Deck"].textures) return;

        //let textures = loader.resources;
        if (this.showfront) {
            let textureCard = PIXI.Texture.from("CardBack.png");
            if (textureCard) {
                this.texture = textureCard;
            }
        } else {
            var cardNumber = this.number;
            if (this.number === 1) cardNumber = "A";
            if (this.number === 11) cardNumber = "J";
            if (this.number === 12) cardNumber = "Q";
            if (this.number === 13) cardNumber = "K";

            let cardSuit = this.suit.toUpperCase();

            let textureId = cardNumber + cardSuit + '.png'
            let textureCard = PIXI.Texture.from(textureId);
            if (textureCard) {
                this.texture = textureCard;
            }
        }
        if (this.grayedOut) {
            this.tint = 0x808080;
        } else {
            this.tint = 0xFFFFFF;
        }
    }
    randomTexture() {

        // var numbers = ["2","3","4","5","6","7","8","9","10","A","K","Q","J"];
        // var cardNumber =numbers[Math.floor(Math.random()*numbers.length)];
        // //var cardNumber = Math.floor(Math.random() * 9 + 1)+1;

        // var suits = ["C","D","H","S"];
        // var cardSuit = suits[Math.floor(Math.random()*suits.length)];

    }
    onDragStart(event) {
        // store a reference to the data
        // the reason for this is because of multitouch
        // we want to track the movement of this particular touch
        this.data = event.data;
        //this.alpha = 0.5;
        this.dragging = true;

        this.onChange();
    }

    onDragEnd(arg) {
        this.alpha = 1;
        this.dragging = false;
        // set the interaction data to null
        this.data = null;
        this.onChange();
    }

    onDragMove(arg) {
        if (this.dragging) {
            var newPosition = this.data.getLocalPosition(this.parent);
            this.x = newPosition.x;
            this.y = newPosition.y;
            this.onChange();
        }
    }

}
